import { HostListener, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private currentViewport$: Subject<
    'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  > = new Subject();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  private getViewportName(
    width: number,
  ): 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' {
    if (width <= 320) return 'xxs';
    if (width <= 375) return 'xs';
    if (width <= 768) return 's';
    if (width <= 1024) return 'm';
    if (width <= 1200) return 'l';
    if (width <= 1440) return 'xl';
    return 'xxl';
  }

  init() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.currentViewport$.next(this.getViewportName(window.innerWidth));

    window.addEventListener('resize', (event) => {
      this.currentViewport$.next(this.getViewportName(window.innerWidth));
    });

    window.addEventListener('orientationchange', (event) => {
      this.currentViewport$.next(this.getViewportName(window.innerWidth));
    });
  }

  getViewport() {
    return this.currentViewport$;
  }
}
